import React from "react";
import {
  Box,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
  Card,
  CardContent,
  Grid,
  Collapse,
  Divider,
  IconButton,
} from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { Formik, Form, FieldArray } from "formik";
import { sidebar } from "utility/data";

const defaultActions = ["view", "add", "edit", "delete"];

function Step3({ initialData, onNext, onBack }) {
  // const generateInitialModules = () => {
  //   return sidebar.map((mod) => {
  //     const subModules = mod.subModules.map((sub) => ({
  //       name: sub,
  //       access: false,
  //       actions: defaultActions.map((act) => ({
  //         name: act,
  //         access: false,
  //       })),
  //     }));

  //     return {
  //       name: mod.name,
  //       access: false,
  //       expand: subModules.length > 0, // 👈 set expand only if subModules exist
  //       subModules,
  //     };
  //   });
  // };

  const mergeModules = (backendModules = []) => {
    return sidebar.map((mod) => {
      // Check if this module already exists in backend
      const existingModule = backendModules.find((m) => m.name === mod.name);

      // Build subModules from sidebar
      const sidebarSubModules = mod.subModules.map((sub) => {
        const defaultSub = {
          name: sub,
          access: false,
          actions: defaultActions.map((act) => ({
            name: act,
            access: false,
          })),
        };

        // If backend has this subModule, merge
        const existingSub =
          existingModule?.subModules?.find((s) => s.name === sub) || null;

        if (existingSub) {
          // Merge actions too
          const mergedActions = defaultSub.actions.map((act) => {
            const existingAct =
              existingSub.actions?.find((a) => a.name === act.name) || null;
            return existingAct || act;
          });

          return {
            ...defaultSub,
            ...existingSub,
            actions: mergedActions,
          };
        }

        return defaultSub;
      });

      if (existingModule) {
        return {
          ...existingModule,
          name: mod.name,
          expand: sidebarSubModules.length > 0,
          subModules: sidebarSubModules,
        };
      }

      return {
        name: mod.name,
        access: false,
        expand: sidebarSubModules.length > 0,
        subModules: sidebarSubModules,
      };
    });
  };

  // const initialValues = {
  //   modules: initialData?.modules?.length
  //     ? initialData.modules
  //     : generateInitialModules(),
  // };

  const initialValues = {
    modules: mergeModules(initialData?.modules),
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={async (values, { setSubmitting }) => {
        console.log("Final values", values);
        onNext(values);
      }}
    >
      {({ values, setFieldValue, isSubmitting }) => (
        <Form>
          <Box className="container py-4">
            <Typography variant="h4" gutterBottom>
              Assign Staff Access
            </Typography>

            <Grid container spacing={2}>
              {values.modules.map((module, modIdx) => (
                <Grid item xs={12} md={6} key={modIdx}>
                  <Card variant="outlined" sx={{ borderRadius: 3 }}>
                    <CardContent>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={module.access}
                              onChange={(e) =>
                                setFieldValue(
                                  `modules[${modIdx}].access`,
                                  e.target.checked
                                )
                              }
                            />
                          }
                          label={
                            <Typography variant="h6">{module.name}</Typography>
                          }
                        />

                        <IconButton
                          onClick={() =>
                            setFieldValue(
                              `modules[${modIdx}].expand`,
                              !module.expand
                            )
                          }
                        >
                          {module.expand ? <ExpandLess /> : <ExpandMore />}
                        </IconButton>
                      </Box>

                      <Collapse in={module.expand && module.access}>
                        <Divider sx={{ mb: 2 }} />
                        {module.subModules.map((sub, subIdx) => (
                          <Box key={subIdx} sx={{ mb: 2 }}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={sub.access}
                                  onChange={(e) =>
                                    setFieldValue(
                                      `modules[${modIdx}].subModules[${subIdx}].access`,
                                      e.target.checked
                                    )
                                  }
                                />
                              }
                              label={
                                <Typography
                                  variant="subtitle1"
                                  fontWeight={600}
                                >
                                  {sub.name}
                                </Typography>
                              }
                            />

                            <Collapse in={sub.access}>
                              <Grid container spacing={1} sx={{ pl: 4 }}>
                                {sub.actions.map((action, actIdx) => (
                                  <Grid item xs={6} sm={4} key={actIdx}>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          checked={action.access}
                                          onChange={(e) =>
                                            setFieldValue(
                                              `modules[${modIdx}].subModules[${subIdx}].actions[${actIdx}].access`,
                                              e.target.checked
                                            )
                                          }
                                        />
                                      }
                                      label={action.name}
                                    />
                                  </Grid>
                                ))}
                              </Grid>
                            </Collapse>
                          </Box>
                        ))}
                      </Collapse>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>

            {/* Navigation Buttons */}
            <Box display="flex" justifyContent="flex-end" gap={2} mt={4}>
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                onClick={() => onBack(values)}
              >
                Back
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={isSubmitting}
              >
                Next
              </Button>
            </Box>
          </Box>
        </Form>
      )}
    </Formik>
  );
}

export default Step3;
